import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
var scriptsStore = {};

var head = __CLIENT__ && document.getElementsByTagName('head')[0];

var noop = function noop() {};

var loadScript = function loadScript(path) {
  return new Promise(function (res) {
    if (!head) {
      return;
    }

    var script = document.createElement('script');
    script.src = path;
    script.addEventListener('load', res);
    head.appendChild(script); // eslint-disable-next-line no-console
  }).catch(function (error) {
    return console.error("Failed to load path [".concat(path, "]: ").concat(error));
  });
};

export var load = function load(path) {
  return scriptsStore[path] || (scriptsStore[path] = loadScript(path));
};
export var loadAll = function loadAll(list, callback) {
  return Promise.all(list.map(load)).then(callback || noop);
};
export default load;